import { Tooltip, Typography } from 'antd'

const { Text } = Typography

export type SourceRef = {
  item_id: number
  title?: string
  scope?: string
  created_by?: string | null
  created_at?: string | null
}

type Props = {
  refs?: SourceRef[] | null
  title?: string
  emptyText?: string
  compact?: boolean
}

export function ChatSourceRefList({
  refs,
  title,
  emptyText = '无来源文档',
  compact = false,
}: Props) {
  const list = refs?.filter((r) => r.item_id > 0) ?? []
  if (!list.length) {
    return (
      <Text type="secondary" style={{ fontSize: compact ? 12 : 13 }}>
        {emptyText}
      </Text>
    )
  }
  const heading = title ?? `参考来源（${list.length} 篇）`
  return (
    <div className={`chat-msg-sources${compact ? ' chat-msg-sources--compact' : ''}`}>
      <div className="chat-msg-sources-title">{heading}</div>
      <ul className="chat-msg-sources-list">
        {list.map((r) => {
          const label = r.title?.trim() || `文档 #${r.item_id}`
          return (
            <li key={r.item_id} className="chat-msg-sources-item">
              <Tooltip title={label} placement="topLeft">
                <span className="chat-msg-sources-doc chat-msg-sources-doc--static">{label}</span>
              </Tooltip>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
